// import 'core-js/actual/promise';      // Para IE 11
// import 'regenerator-runtime/runtime'; // Para IE 11
import { getCookie, formToJsonObj, debounce, fetch$, fadeIn, fadeOut } from 'dascat-utils';
import { toggleLoader, showFormErrors, showFormGlobalError } from './shared';

import 'tw-elements';

function ready() {
  toggleLoader(false);

  document.getElementById('submit-button').addEventListener('click', debounce(async (ev) => {
    ev.preventDefault();

    const formEl = document.getElementById("submit-form");

    if (!formEl.reportValidity()) {
      return;
    }

    const formObj = formToJsonObj(formEl);

    toggleLoader(true);

    try {
      const res = await fetch$(`/submit/${bname}/`, {
        method: 'POST',
        headers: { "X-CSRFToken": getCookie('csrftoken') },
        body: JSON.stringify(formObj),
      });

      if (res.success) {
        if ('redirect_url' in res) {
          window.location = res.redirect_url;
          toggleLoader(false);
        } else {
          const feedbackEl = document.getElementById("feedback-success")
          if ('message' in res) {
            feedbackEl.children[0].innerText = "Boa! A tua Mensagem foi submetida e aguarda validação.";
          }
          fadeOut(formEl, 200, () => {
            formEl.style.display = 'none';
            fadeIn(feedbackEl, 200, () => {
              toggleLoader(false);
            });
          });
        }
      } else {
        toggleLoader(false);
        showFormErrors(formEl, res.errors);
        // alert(JSON.stringify(res));
      }
    } catch (e) {
      console.log(e)
      toggleLoader(false);
      showFormGlobalError(formEl, 'Ocorreu um erro! Por favor, volte a tentar de novo.');
      return;
    }

  }));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ready);
} else {
  ready();
}
